// Предохранитель записи: столько-то отказов подряд по одной строке за короткое окно — запись по ней
// останавливается до перезагрузки страницы. Защита от цикла «запись → отказ → запись», откуда бы он ни
// взялся: пять вызовов вместо миллионов. Чистая модель без React и сети. Ключ — `таблица:id`, у вставки без
// id — `таблица:insert`: повторяющаяся отклонённая вставка считается по таблице.

export class WriteBreaker {
  private readonly fails = new Map<string, number[]>();
  private readonly open = new Set<string>();

  constructor(private readonly limit = 5, private readonly windowMs = 10_000) {}

  /** Отказ записи по ключу; true — предохранитель сработал (в этот раз или раньше). */
  fail(key: string, now: number): boolean {
    if (this.open.has(key)) return true;
    const recent = (this.fails.get(key) ?? []).filter((t) => now - t < this.windowMs);
    recent.push(now);
    this.fails.set(key, recent);
    if (recent.length >= this.limit) { this.open.add(key); this.fails.delete(key); return true; }
    return false;
  }

  /** Успешная запись по ключу закрывает счёт отказов (сработавший предохранитель не сбрасывается). */
  ok(key: string): void { this.fails.delete(key); }

  isOpen(key: string): boolean { return this.open.has(key); }
  get tripped(): boolean { return this.open.size > 0; }
}
